export default "__VITE_ASSET__DlUwfRZU__"